import { ComponentProps, FC } from 'react'

import { Box } from './box.styles'

const Fixed: FC<Omit<ComponentProps<typeof Box>, 'position'>> = (props) => {
  return <Box position="fixed" {...props} />
}

export default Fixed
